var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.myProps.customizables.round?'completo round':'completo'},[(_vm.url != null)?_c('v-img',{class:_vm.myProps.customizables.round?'fullimage round':'fullimage completo',attrs:{"src":_vm.url}}):_vm._e(),_vm._v(" "+_vm._s(this.myProps.customizables.images.find(e=>e.includes('null')))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }